"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.frakturBold = {
    0x20: [0, 0, .25],
    0x21: [.689, .012, .349],
    0x22: [.695, -0.432, .254],
    0x26: [.696, .016, .871],
    0x27: [.695, -0.436, .25],
    0x28: [.737, .186, .459],
    0x29: [.735, .187, .459],
    0x2A: [.692, -0.449, .328],
    0x2B: [.598, .082, .893],
    0x2C: [.107, .191, .328],
    0x2D: [.275, -0.236, .893],
    0x2E: [.102, .015, .328],
    0x2F: [.721, .182, .593],
    0x30: [.501, .012, .593],
    0x31: [.489, 0, .593],
    0x32: [.491, 0, .593],
    0x33: [.487, .193, .593],
    0x34: [.495, .196, .593],
    0x35: [.481, .19, .593],
    0x36: [.704, .012, .593],
    0x37: [.479, .197, .593],
    0x38: [.714, .005, .593],
    0x39: [.487, .195, .593],
    0x3A: [.457, .012, .255],
    0x3B: [.458, .19, .255],
    0x3D: [.343, -0.168, .582],
    0x3F: [.697, .014, .428],
    0x41: [.686, .031, .847],
    0x42: [.684, .031, 1.044],
    0x43: [.676, .032, .723],
    0x44: [.683, .029, .982],
    0x45: [.686, .029, .783],
    0x46: [.684, .146, .722],
    0x47: [.687, .029, .927],
    0x48: [.683, .126, .851],
    0x49: [.681, .025, .655],
    0x4A: [.68, .141, .652],
    0x4B: [.681, .026, .789, { ic: .017 }],
    0x4C: [.683, .028, .786],
    0x4D: [.683, .032, 1.239],
    0x4E: [.679, .03, .983],
    0x4F: [.726, .03, .976],
    0x50: [.688, .223, .977],
    0x51: [.726, .083, .976],
    0x52: [.688, .028, .978],
    0x53: [.685, .031, .978],
    0x54: [.686, .03, .79, { ic: .012 }],
    0x55: [.688, .039, .851, { ic: .02 }],
    0x56: [.685, .029, .982],
    0x57: [.683, .03, 1.235],
    0x58: [.681, .035, .849],
    0x59: [.688, .214, .984],
    0x5A: [.677, .148, .711],
    0x5B: [.74, .13, .257],
    0x5D: [.738, .132, .257],
    0x5E: [.734, -0.452, .59],
    0x61: [.472, .032, .603],
    0x62: [.69, .032, .59],
    0x63: [.473, .026, .464],
    0x64: [.632, .028, .589],
    0x65: [.471, .027, .472],
    0x66: [.687, .222, .388],
    0x67: [.472, .208, .595],
    0x68: [.687, .207, .615],
    0x69: [.686, .025, .331],
    0x6A: [.682, .203, .332],
    0x6B: [.682, .025, .464],
    0x6C: [.681, .024, .337],
    0x6D: [.476, .031, .921],
    0x6E: [.473, .028, .654],
    0x6F: [.482, .034, .609],
    0x70: [.557, .207, .604],
    0x71: [.485, .211, .596],
    0x72: [.472, .026, .46],
    0x73: [.479, .034, .523],
    0x74: [.648, .027, .393, { ic: .014 }],
    0x75: [.472, .032, .589, { ic: .014 }],
    0x76: [.546, .027, .604],
    0x77: [.549, .032, .918],
    0x78: [.471, .188, .459],
    0x79: [.557, .221, .589],
    0x7A: [.471, .214, .461],
    0xA0: [0, 0, .25],
    0x391: [.698, 0, .869],
    0x392: [.686, 0, .818],
    0x395: [.68, 0, .756],
    0x396: [.686, 0, .703],
    0x397: [.686, 0, .9],
    0x399: [.686, 0, .436],
    0x39A: [.686, 0, .901],
    0x39C: [.686, 0, 1.092],
    0x39D: [.686, 0, .9],
    0x39F: [.696, .01, .864],
    0x3A1: [.686, 0, .786],
    0x3A2: [.696, .01, .894],
    0x3A4: [.675, 0, .8],
    0x3A7: [.686, 0, .869],
    0x3D2: [.697, 0, .894],
    0x3DC: [.68, 0, .724],
    0x2018: [.708, -0.411, .254],
    0x2019: [.692, -0.394, .254],
    0x2044: [.721, .182, .593],
    0xE301: [.63, .027, .587],
    0xE302: [.693, .212, .394, { ic: .014 }],
    0xE303: [.681, .219, .387],
    0xE304: [.473, .212, .593],
    0xE305: [.684, .027, .393],
    0xE308: [.679, .22, .981],
    0xE309: [.717, .137, .727],
};
//# sourceMappingURL=fraktur-bold.js.map